import { useState } from "react";
import { useSuppliers, Supplier } from "@/hooks/useSuppliers";
import { SupplierFormDialog } from "@/components/suppliers/SupplierFormDialog";
import { SupplierList } from "@/components/suppliers/SupplierList";
import { Button } from "@/components/ui/button";
import { Plus, Truck } from "lucide-react";

export default function FornecedoresPage() {
  const [showInactive, setShowInactive] = useState(false);
  const {
    suppliers,
    isLoading,
    createSupplier,
    updateSupplier,
    toggleSupplierActive,
  } = useSuppliers({ includeInactive: showInactive });

  const [dialogOpen, setDialogOpen] = useState(false);
  const [dialogMode, setDialogMode] = useState<"create" | "edit">("create");
  const [editingSupplier, setEditingSupplier] = useState<Supplier | null>(null);

  const handleCreate = () => {
    setDialogMode("create");
    setEditingSupplier(null);
    setDialogOpen(true);
  };

  const handleEdit = (supplier: Supplier) => {
    setDialogMode("edit");
    setEditingSupplier(supplier);
    setDialogOpen(true);
  };

  const handleToggleActive = async (supplier: Supplier) => {
    await toggleSupplierActive(supplier.id, !supplier.is_active);
  };

  return (
    <div className="space-y-6">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4">
        <div className="flex items-center gap-3">
          <Truck className="h-6 w-6 text-primary" />
          <div>
            <h1 className="text-2xl font-bold tracking-tight">Fornecedores / Credores</h1>
            <p className="text-muted-foreground text-sm">
              Gerencie seus fornecedores e credores para vincular às despesas.
            </p>
          </div>
        </div>
        <Button onClick={handleCreate}>
          <Plus className="mr-2 h-4 w-4" />
          Novo fornecedor
        </Button>
      </div>

      <SupplierList
        suppliers={suppliers}
        isLoading={isLoading}
        showInactive={showInactive}
        onShowInactiveChange={setShowInactive}
        onEdit={handleEdit}
        onToggleActive={handleToggleActive}
      />

      <SupplierFormDialog
        open={dialogOpen}
        onOpenChange={setDialogOpen}
        mode={dialogMode}
        supplier={editingSupplier}
        onCreate={createSupplier}
        onUpdate={updateSupplier}
      />
    </div>
  );
}
